import { render, staticRenderFns } from "./edit-field.vue?vue&type=template&id=386d80fd&scoped=true"
import script from "./edit-field.vue?vue&type=script&lang=js"
export * from "./edit-field.vue?vue&type=script&lang=js"
import style0 from "./edit-field.vue?vue&type=style&index=0&id=386d80fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386d80fd",
  null
  
)

export default component.exports